export const stats: [string, string][] = [
  ['6', 'VOLUMI COMPLETI'],
  ['480', 'PAGINE ILLUSTRATE'],
  ['120', 'ESERCIZI SCHEDATI'],
  ['100%', 'PRONTO DA STAMPARE'],
]
